module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-us full-screen"
  }, [_c('nav', {
    staticClass: "navbar navbar-ct-default",
    attrs: {
      "role": "navigation-demo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Go to home")])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navigation-example-2"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-full-page section content"
  }, [_c('div', {}, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 text-center"
  }, [_c('h2', {
    staticClass: "title text-danger"
  }, [_vm._v("404 Not Found")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Oops! It seems that this page does not exist.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0cb06edd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/NotFoundPage.vue
// module id = 725
// module chunks = 0